<template>
    <modal style="z-index: 9999;" :show="showModal" :show-close="true" @close="$store.dispatch('config/change',{customer: false, location: false})">
        <template slot="header">
            <h2 class="modal-title" id="exampleModalLabel">Organisation ändern</h2>
        </template>
        <div>
            <div class="table-responsive">
                <base-table thead-classes="thead-light"
                            tbody-classes="light"
                            table-classes="scrollable"
                            :data="customers">
                    <template slot="columns">
                        <th>Organisation</th>
                        <th></th>
                    </template>
                    <template v-slot="{row}">
                        <th scope="row">
                            <div v-if="$store.getters['customer/isLoading']" class="loading"> </div><div v-else>{{ row.name }}</div>
                        </th>
                        <td>
                            <div v-if="$store.getters['customer/isLoading']" class="loading-button"> </div><div v-else><base-button icon="ni ni-check-bold" size="sm" type="primary" @click="setCustomer(row)"></base-button></div>
                        </td>
                    </template>
                </base-table>
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        name:"ChangeOrganisation",
        props: {
            showModal: {
                type: Boolean
            }
        },
        computed: {
            customers() {
                return (this.$store.getters['customer/isReady']) ? this.$store.getters['customer/showCustomerCollection'] : [];
            }
        },
        methods: {
            setCustomer(customer) {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = {customer: customer.id};
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/changecustomer`, requestOptions)
                        .then(this.handleResponse)
                        .then(() => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/success', 'Die Organisation wurde geändert.');
                                this.$store.dispatch('config/change',{customer: false, location: false});
                                this.$store.dispatch('authentication/onRefresh');

                                this.$store.dispatch('location/getLocationCollection');
                                this.$store.dispatch('profiles/getProfiles');
                                this.$router.push('/')
                            },
                            error => {
                                this.isLoading = false;
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
        }
    }
</script>

<style scoped>

</style>